import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ResultsSection() {
  return <section className="py-24 bg-white" data-id="element-139">
      <div className="container mx-auto px-6 max-w-3xl text-center" data-id="element-140">
        <FadeIn data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26] mb-10" data-id="element-142">
            ¿Qué cambia en 7 días?
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-143">
          <div className="relative" data-id="element-144">
            <span className="absolute top-0 left-0 text-6xl text-[#E8EDE6] font-serif -translate-x-6 -translate-y-6 select-none" data-id="element-145">
              "
            </span>
            <p className="text-xl md:text-2xl text-[#4A6741] font-serif leading-relaxed italic relative z-10" data-id="element-146">
              No prometo milagros imposibles, pero te garantizo esto: en una
              semana dejarás de sentir esa presión constante en el abdomen. Tu
              digestión será silenciosa, tu energía será estable y ese pantalón
              que hoy te aprieta, volverá a cerrar con suavidad.
            </p>
            <span className="absolute bottom-0 right-0 text-6xl text-[#E8EDE6] font-serif translate-x-6 translate-y-8 select-none" data-id="element-147">
              "
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}